<template>
    <div class="contacts">
        <z-tabs>
            <template v-slot:label>
                <z-tabs-label id="general" v-if="$slots['general']">
                    <span v-html="text.general"></span>
                </z-tabs-label>
                <z-tabs-label id="assets" v-if="$slots['assets'] || (contacts && contacts.assets)">
                    <span v-html="text.assets"></span>
                </z-tabs-label>
                <!-- <z-tabs-label id="suppliers" v-if="$slots['suppliers'] || contacts && contacts.suppliers">
                    <span v-html="text.suppliers"></span>
                </z-tabs-label> -->
                <z-tabs-label id="investors" v-if="$slots['investors'] || contacts && contacts.investors">
                    <span v-html="text.investors"></span>
                </z-tabs-label>
                <z-tabs-label id="press" v-if="$slots['press'] || contacts && contacts.press">
                    <span v-html="text.press"></span>
                </z-tabs-label>
                <z-tabs-label id="hr" v-if="$slots['hr'] || contacts && contacts.hr">
                    <span v-html="text.hr"></span>
                </z-tabs-label>
                <z-tabs-label id="customers" v-if="$slots['customers'] || contacts && contacts.customers">
                    <span v-html="text.customers"></span>
                </z-tabs-label>
            </template>
            <template v-slot:content>
                <z-tabs-content id="general" v-if="$slots['general']">
                    <slot name="general"></slot>
                </z-tabs-content>
                <z-tabs-content id="assets" v-if="$slots['assets'] || contacts && contacts.assets">
                    <assets :data="contacts.assets">
                        <slot name="assets"></slot>
                    </assets>
                </z-tabs-content>
                <!-- <z-tabs-content id="suppliers" v-if="$slots['assets'] || (contacts && contacts.assets)">
                    <detail :data="contacts.suppliers">
                        <slot name="suppliers" />
                    </detail>
                </z-tabs-content> -->
                <z-tabs-content id="investors" v-if="$slots['investors'] || contacts && contacts.investors">
                    <investors-detail :data="contacts.investors"></investors-detail>
                </z-tabs-content>
                <z-tabs-content id="press" v-if="$slots['press'] || contacts && contacts.press">
                    <detail :data="contacts.press">
                        <slot name="press" />
                    </detail>
                </z-tabs-content>
                <z-tabs-content id="hr" v-if="$slots['hr'] || contacts && contacts.hr">
                    <detail :data="contacts.hr">
                        <slot name="hr" />
                    </detail>
                </z-tabs-content>
                <z-tabs-content id="customers" v-if="$slots['customers'] || contacts && contacts.customers">
                    <customers-detail v-if="$root.lang === 'ru'" :data="contacts.customers" hidden-contacts></customers-detail>
                    <detail v-else :data="contacts.customers" hidden-contacts>
                        <slot name="customers" />
                    </detail>
                </z-tabs-content>
            </template>
        </z-tabs>

    </div>
</template>

<script>
import { localize } from '@/utils/i18n'
import Assets from './components/Assets.vue'
import Detail from './components/Detail.vue'

export default {
    name: 'contacts',
    data () {
        return {
            text: {
                general: localize({
                    'ru': 'Общие контакты',
                    'en': 'General'
                }),
                assets: localize({
                    'ru': 'Предприятия',
                    'en': 'Assets'
                }),
                suppliers: localize({
                    'ru': 'Поставщикам',
                    'en': 'Suppliers'
                }),
                investors: localize({
                    'ru': 'Для инвесторов',
                    'en': 'Investors'
                }),
                press: localize({
                    'ru': 'Для СМИ',
                    'en': 'Media'
                }),
                hr: localize({
                    'ru': 'Карьера',
                    'en': 'Career'
                }),
                customers: localize({
                    'ru': 'Для покупателей',
                    'en': 'Customers'
                })
            }
        }
    },
    components: {
        Assets,
        Detail
    },
    computed: {
        contacts () {
            if (!this.$root.app.components.contacts) return
            return this.$root.app.components.contacts
        }
    }
}
</script>

<style lang="scss">
.contacts {
    &__col {
        display: flex;

        > div {
            width: 100%;
        }
    }

    &__card {
        width: 100%;

        .z-card__body {
            min-height: 200px;
        }

        &--with-icon {
            .z-card__body {
                padding-bottom: $token-spacers-s;
            }
        }
    }
}
</style>
